import { render, staticRenderFns } from "./TableRowPercentNewPatientsOnScit.vue?vue&type=template&id=5f96b0be&lang=pug&"
import script from "./TableRowPercentNewPatientsOnScit.vue?vue&type=script&lang=js&"
export * from "./TableRowPercentNewPatientsOnScit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f96b0be')) {
      api.createRecord('5f96b0be', component.options)
    } else {
      api.reload('5f96b0be', component.options)
    }
    module.hot.accept("./TableRowPercentNewPatientsOnScit.vue?vue&type=template&id=5f96b0be&lang=pug&", function () {
      api.rerender('5f96b0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowPercentNewPatientsOnScit.vue"
export default component.exports